import { Certificate, ICertificate } from '../certificate';
import { DpExperience, IDpExperience } from './dp-experience';

export interface IDpInfo {
  dp_certificates?: ICertificate[];
  dp_courses?: ICertificate[];
  dp_experience_after?: IDpExperience[];
  dp_experience_before?: IDpExperience[];

}

export class DpInfo implements IDpInfo {
  dp_certificates?: Certificate[];
  dp_courses?: Certificate[];
  dp_experience_after?: DpExperience[];
  dp_experience_before?: DpExperience[];

  constructor( dpInfo: IDpInfo = {} ) {
    this.dp_certificates = this.transformCertificates(dpInfo.dp_certificates);
    this.dp_courses = this.transformCertificates(dpInfo.dp_courses);
    this.dp_experience_after = this.transformExperiences(dpInfo.dp_experience_after);
    this.dp_experience_before = this.transformExperiences(dpInfo.dp_experience_before);
  }

  private transformCertificates( certificates: ICertificate[] = [] ): Certificate[] {
    return certificates.map(( certificate ) => new Certificate(certificate));
  }

  private transformExperiences( experinces: IDpExperience[] = [] ): DpExperience[] {
    return experinces.map(( experince ) => new DpExperience(experince));
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/dp-info.ts